
import { ServiceResultItem } from "./ServiceResultItem";
import { apiCommonCall } from "../broadly-review/api-call";
import { apiConfig } from "../config";
import { getBrandList } from "./getBrandList";
import { stop_loader } from "./stop_loader";

export async function NPSScore(value: ServiceResultItem,fn:any){
    if (!value.npsScore || value.netPromoterStarRating <= 0){
        fn({});
    }
    else{
        const afterCom = window.location.href.split('.com')[1];
        const isWebSite =  afterCom.split('/')[1].replace(/[^a-zA-Z ]/g, "") === "ca" ? "ca" : "us";
        let badge_url= isWebSite == "ca" ? "/ca" : "";
        getBrandList(function(data:any){
            if(data.length > 0){
                let CountryCode = window.location.href.split('.com')[1];
                let countryID =  CountryCode.split('/')[1].replace(/[^a-zA-Z ]/g, "") === "ca" ? 2 : 1;
                localStorage.removeItem('brand_c_id');
                localStorage.removeItem('minimum_rating');
                let pageNumber = 1;
                let pageSize = 10;
                let concept_id:any = value.conceptID;
                let filterData = data.find((el:any)=>el.id == concept_id);
                let minimumRating = filterData?.minimumReviewRating ? filterData?.minimumReviewRating : '';

                localStorage.setItem('brand_c_id',concept_id);
                localStorage.setItem('minimum_rating',minimumRating);
                let url:any = `${apiConfig.reviewaggregates}&ConceptId=${value.conceptID}&CountryId=${countryID}&MinimumRating=${minimumRating}&PageNumber=${pageNumber}&PageSize=${pageSize}&FranchiseWebLocationId=${value.franchiseWebLocationId}`;
                apiCommonCall(url,function(result:any){
                    stop_loader();
                    let overallRating = result[0]?.overallRating;
                    let displayCount = result[0]?.grandTotal;
                    fn({overallRating,displayCount,badge_url,value});
                },function (data:any, status:any){
                    stop_loader();
                    if(status == "error"){
                        fn({});
                    }
                });
            } 
        });
    }
}
